import type { ClassifierCategory } from '@repo/api-codegen';

export const getPIIClassifierLabel = (classifier: ClassifierCategory) => {
	switch (classifier) {
		case 'PII.MEDICAL':
			return 'Medical Information';
		case 'PII.CONTACT':
			return 'Contact Information';
		case 'PII.IDENTITY':
			return 'Identity Information';
		case 'PII.FINANCIAL':
			return 'Financial Information';
		case 'PII.ONLINE':
			return 'Online Information';
		case 'PII.ID_NUMBERS':
			return 'ID Numbers';
		default:
			return '';
	}
};
